/*
  Russian dictionary: English source strings → Russian. Started as the
  inversion of the pre-English-first dictionary, hand-tuned where two
  Russian originals had collapsed into one English string, extended with
  the server's error and label strings.

  Adding another language works the same way: copy this file, translate
  the values, add a plural table (see ruPlurals — Russian needs three
  forms where English needs two) and wire the language into i18n.ts.
*/

export const ru: Record<string, string> = {
  ' — none yet': ' — ещё нет',
  ' · personal': ' · личный',
  ' (personal)': ' (личный)',
  'A red bicycle': 'Красный велосипед',
  'All of us': 'Все свои',
  'Allergies': 'Аллергии',
  'Allergies and medical notes': 'Аллергии и медицинские заметки',
  'Already reserved': 'Уже забронировано',
  'appears in the shared calendar with the age': 'появится в общем календаре, с возрастом',
  'Birthday': 'День рождения',
  'Daughter': 'Дочь',
  'Delete wish': 'Удалить желание',
  'e.g. nuts, penicillin': 'например: орехи, пенициллин',
  'Enter a label': 'Укажите название',
  'Enter a wish': 'Напишите желание',
  'Enter adds': 'Enter добавляет',
  'Enter your name': 'Представьтесь',
  'Entry not found': 'Запись не найдена',
  'Family role': 'Роль в семье',
  'Father': 'Папа',
  'Grandfather': 'Дедушка',
  'Grandmother': 'Бабушка',
  'Guests see the wishes and can reserve; reservations are hidden from {name}.': 'Гости видят желания и могут бронировать; брони скрыты от {name}.',
  'link (optional)': 'ссылка (не обязательно)',
  'Mother': 'Мама',
  'None known — good.': 'Ничего не известно — и хорошо.',
  'Nothing wished for yet.': 'Пока никаких желаний.',
  'Preferences': 'Предпочтения',
  'Remove {name}': 'Убрать {name}',
  'Reservations are a surprise: {name} does not see them.': 'Брони — сюрприз: {name} их не видит.',
  'Reserve': 'Забронировать',
  'Reserved': 'Занято',
  'Reserved by someone else': 'Забронировано кем-то другим',
  'Reserved by you — release': 'Забронировано вами — отпустить',
  'Reserved: {name}': 'Забронировано: {name}',
  'Share with guests — a link without an account': 'Поделиться с гостями — ссылка без аккаунта',
  'Shoes': 'Обувь',
  'Sizes, favourite tea, the things you need in a shop and never remember.': 'Размеры, любимый чай — то, что нужно в магазине и никогда не вспомнить.',
  'Son': 'Сын',
  'The link must be a full URL': 'Ссылка должна быть полным адресом',
  'This link is no longer valid': 'Эта ссылка больше не действует',
  'This profile belongs to someone else': 'Это чужой профиль',
  'Who we are': 'Кто мы',
  'Wish for something — the family is watching.': 'Загадайте что-нибудь — семья смотрит.',
  'Wish not found': 'Желание не найдено',
  'Wishlist': 'Вишлист',
  '{n} years old': '{n} лет',
  '“{title}” and its attachments will be deleted permanently.': '«{title}» и её вложения будут удалены безвозвратно.',
  '“{title}” does not exist yet. Create it now?': '«{title}» ещё не создана. Создать сейчас?',
  '“{title}” will be deleted.': '«{title}» будет удалено.',
  '“{title}” will disappear from all dates, including past ones.': '«{title}» исчезнет из всех дат, включая прошедшие.',
  '{{author}}': '{{автор}}',
  '{{date}}': '{{дата}}',
  '{{iso}}': '{{изо}}',
  '{{time}}': '{{время}}',
  '{n} B': '{n} Б',
  '{name} will be signed out on all devices and given a new password.': '{name} будет разлогинен на всех устройствах и получит новый пароль.',
  '{unit} ago': '{unit} назад',
  '← List': '← Список',
  '+ account': '+ счёт',
  '+ budget': '+ лимит',
  '+ calendar': '+ календарь',
  '+ category': '+ категория',
  '+ expense': '+ трата',
  '+ folder': '+ папка',
  '+ income': '+ доход',
  '+ project': '+ проект',
  '+ recurring transaction': '+ регулярная операция',
  'A category cannot be its own parent': 'Категория не может быть родителем самой себя',
  'A day before': 'За день',
  'A limit on a parent category also counts its subcategories': 'Лимит на родительскую категорию учитывает и траты её подкатегорий',
  'A list of tasks is expected': 'Ожидается список задач',
  'A month before': 'За месяц',
  'A month in YYYY-MM format is required': 'Нужен месяц в формате ГГГГ-ММ',
  'A move, a trip, a new bike — the widget title': 'Переезд, поездка, новый велосипед — заголовок виджета',
  'A note for this date already exists, and it is private': 'Заметка на эту дату уже есть, и она приватная',
  'A one-off exception. Other months keep the standing budget': 'Разовое исключение. В остальных месяцах останется постоянный лимит',
  'A per-device setting: a phone and the shared kiosk can speak different languages.': 'Настройка этого устройства: телефон и общий стенд могут говорить на разных языках.',
  'In the demo, switching also starts a fresh sample family in that language.':
    'В демо переключение ещё и заводит новую примерную семью на этом языке.',
  'A private note is visible only to its owner': 'Приватную заметку видит только её владелец',
  'A receipt can be attached after the transaction is saved.': 'Чек можно приложить после сохранения операции.',
  'A subcategory cannot be a parent': 'Подкатегория не может быть родителем',
  'A task cannot be nested inside itself': 'Задачу нельзя вложить в саму себя',
  'A timed event needs hours and minutes': 'У события со временем нужны часы и минуты',
  'A transfer has no category': 'У перевода категории нет',
  'A transfer needs a destination account and a received amount': 'У перевода нужны счёт получателя и полученная сумма',
  'A transfer needs a destination account and the amount received': 'У перевода нужны счёт получателя и сумма зачисления',
  'A transfer to the same account makes no sense': 'Перевод на тот же счёт лишён смысла',
  'A user with this address already exists': 'Пользователь с таким адресом уже есть',
  'A week before': 'За неделю',
  'About': 'О программе',
  'Account': 'Счёт',
  'Account not found': 'Счёт не найден',
  'Accounts and spending': 'Счета и траты',
  'Actual amount': 'Фактическая сумма',
  'Actual bank balance, {currency}': 'Фактический остаток по банку, {currency}',
  'Add': 'Добавить',
  'Add account': 'Добавить счёт',
  'Add an event on {date}': 'Добавить событие на {date}',
  'Add color': 'Добавить цвет',
  'Add subtask': 'Добавить подзадачу',
  'Add task': 'Добавить задачу',
  'Add widget': 'Добавить виджет',
  'Administrator': 'Администратор',
  'Administrators only': 'Только администратор',
  'Agenda': 'Лента',
  'All': 'Все',
  'All assignees': 'Все исполнители',
  'all day': 'весь день',
  'All day': 'Весь день',
  'All projects': 'Все проекты',
  'All widgets are already on the board.': 'Все виджеты уже на доске.',
  'Amount': 'Сумма',
  'Amount must be greater than zero': 'Сумма должна быть больше нуля',
  'Any priority': 'Любой приоритет',
  'Archive': 'Архив',
  'Assignee': 'Исполнитель',
  'At least 10 characters': 'Не короче 10 символов',
  'At least three characters are needed': 'Нужно минимум три символа',
  'Attach': 'Приложить',
  'Attach a file': 'Прикрепить файл',
  'Attachment storage is full': 'Хранилище вложений заполнено',
  'Attachments': 'Вложения',
  'B': 'Ж',
  'Back': 'Назад',
  'Balance': 'Баланс',
  'Belongs to': 'Входит в',
  'Board': 'Доска',
  'Board and widgets': 'Табло и виджеты',
  'Bold': 'Полужирный',
  'Budget': 'Лимит',
  'Budget not found': 'Лимит не найден',
  'Budgets': 'Лимиты',
  'Budgets only make sense for expense categories': 'Лимит имеет смысл только для категории трат',
  'Build {sha}': 'Сборка {sha}',
  'By category': 'По категориям',
  'Calendar': 'Календарь',
  'Calendar not found': 'Календарь не найден',
  'Cancel': 'Отмена',
  'Cancelled': 'Отменено',
  'Cannot be disabled for the administrator: it is the emergency entrance': 'У администратора не отключается: это аварийный вход',
  'Card': 'Карта',
  'Cash': 'Наличные',
  'Categories': 'Категории',
  'Category': 'Категория',
  'Category not found': 'Категория не найдена',
  'Change password': 'Сменить пароль',
  'Change your password first': 'Сначала смените пароль',
  'Check that the hub server is running, then reload the page.': 'Проверьте, что сервер хаба запущен, и обновите страницу.',
  'Check the entered passwords': 'Проверьте введённые пароли',
  'Check the fields': 'Проверьте поля',
  'Checking': 'Проверяю',
  'Checklist': 'Чеклист',
  'Choose a destination account': 'Выберите счёт получателя',
  'Choose an account': 'Выберите счёт',
  'Click any day in the grid to add an event.': 'Нажмите на любой день в сетке, чтобы добавить событие.',
  'Close': 'Закрыть',
  'Cmd + Shift + F · arrows and Enter': 'Cmd + Shift + F · стрелки и Enter',
  'Code': 'Код',
  'Collapse': 'Свернуть',
  'Color must look like #1F6E8C': 'Цвет задаётся в формате #1F6E8C',
  'Colour': 'Цвет',
  'Colour {color}': 'Цвет {color}',
  'Coming up': 'Ближайшее',
  'Configure account {name}': 'Настроить счёт {name}',
  'Configure calendar {name}': 'Настроить календарь {name}',
  'Configure folder {name}': 'Настроить папку {name}',
  'Configure project {title}': 'Настроить проект {title}',
  'Confirm': 'Подтвердить',
  'Copied': 'Скопировано',
  'Copy': 'Копировать',
  'Could not add': 'Не удалось добавить',
  'Could not change access': 'Не удалось изменить доступ',
  'Could not change the password': 'Не удалось сменить пароль',
  'Could not create the transaction': 'Не удалось создать операцию',
  'Could not link Google. Please try again.': 'Не получилось привязать Google. Попробуйте ещё раз.',
  'Could not load': 'Не удалось загрузить',
  'Could not load budgets': 'Не удалось загрузить лимиты',
  'Could not load tasks': 'Не удалось загрузить задачи',
  'Could not load the calendar': 'Не удалось загрузить календарь',
  'Could not open the note': 'Не удалось открыть заметку',
  'Could not parse the amount': 'Не разобрал сумму',
  'Could not parse the recurrence rule': 'Правило повтора не разобрать',
  'Could not save': 'Не удалось сохранить',
  'Could not save. Check that the server is running': 'Не удалось сохранить. Проверьте, что сервер запущен',
  'Could not sign in': 'Не удалось войти',
  'Could not sign in with Google. Try again or sign in with a password.': 'Не получилось войти через Google. Попробуйте ещё раз или войдите по паролю.',
  'Could not upload the file': 'Не удалось загрузить файл',
  'Could not upload the receipt': 'Не удалось загрузить чек',
  'Create': 'Создать',
  'create a new one': 'создайте новую',
  'Create accounts, reset passwords, disable access': 'Завести учётку, сбросить пароль, отключить доступ',
  'Create an expense category first': 'Сначала заведите категорию трат',
  'Create and sign in': 'Создать и войти',
  'Create automatically': 'Создавать самостоятельно',
  'Create link': 'Создать ссылку',
  'Create the first account — it becomes the administrator: it can invite family members and reset passwords.': 'Создайте первую учётку — она станет администратором: сможет приглашать домочадцев и сбрасывать пароли.',
  'created automatically': 'создаётся сама',
  'Creating': 'Создаю',
  'Credit': 'Зачислить',
  'Cross-site request rejected': 'Запрос с чужого сайта отклонён',
  'Currencies are not added together: there is no exchange rate in the system, so no grand total either.': 'Валюты не складываются: курса в системе нет, поэтому общего итога тоже.',
  'Currency': 'Валюта',
  'Custom color': 'Свой цвет',
  'Customize': 'Настроить',
  'Date': 'Дата',
  'date like 2026-08-02.': 'дата в виде 2026-08-02.',
  'Date must be YYYY-MM-DD': 'Дата в формате ГГГГ-ММ-ДД',
  'Date must be YYYY-MM-DD or YYYY-MM-DDTHH:MM': 'Дата в формате ГГГГ-ММ-ДД или ГГГГ-ММ-ДДTЧЧ:ММ',
  'Day': 'День',
  'Debit': 'Списать',
  'Default currency': 'Валюта по умолчанию',
  'Delete': 'Удалить',
  'Delete event': 'Удалить событие',
  'Delete file': 'Удалить файл',
  'Delete note': 'Удалить заметку',
  'Delete rule': 'Удалить правило',
  'Delete series': 'Удалить серию',
  'Delete task': 'Удалить задачу',
  'Demo': 'Демо',
  'Description': 'Описание',
  'Destination account not found': 'Счёт получателя не найден',
  'Did not happen': 'Не было',
  'Disable': 'Отключить',
  'Disable password sign-in?': 'Отключить вход по паролю?',
  'disabled': 'отключён',
  'Disabled — sign-in via Google only': 'Отключён — вход только через Google',
  'Disabled in demo mode': 'Отключено в демо-режиме',
  'Disabled in the demo': 'Отключено в демо-режиме',
  'Discrepancy': 'Расхождение',
  'Does not fit: tasks nest at most three levels deep': 'Не помещается: глубже трёх уровней задачи не вкладываются',
  'Does not repeat': 'Не повторяется',
  'Done': 'Готово',
  'Drag files into the text or paste from the clipboard': 'Файлы можно перетащить в текст или вставить из буфера',
  'Drop a task here': 'Перетащите задачу сюда',
  'Due date': 'Срок',
  'Expected finish': 'Ожидаемое завершение',
  'Get it on GitHub': 'Забрать на GitHub',
  'Goal': 'Цель',
  'Goal currency': 'Валюта цели',
  'Goal name': 'Название цели',
  'Goal settings': 'Настройки цели',
  'Home name': 'Название дома',
  'A local label for your hub — shows in the sidebar, the sign-in screen and the browser tab. Leave blank for the default.': 'Своё название дома — видно в боковом меню, на экране входа и во вкладке браузера. Пусто — останется Neiliro.',
  'in {unit}': 'через {unit}',
  'Left': 'Останется',
  'Overdue counts from this date': 'Просрочка считается от этой даты',
  'Edit': 'Изменить',
  'Edit the saved amount': 'Изменить накопленную сумму',
  'Empty': 'Пусто',
  'Enable': 'Включить',
  'Enable password sign-in first': 'Сначала включите вход по паролю',
  'Enable password sign-in first — otherwise there is no way left to sign in': 'Сначала включите вход по паролю — иначе входить будет нечем',
  'Enabled. Can be disabled once Google is linked': 'Включён. Отключить можно после привязки Google',
  'Enabled. You may disable it: Google is more secure': 'Включён. Можно отключить: Google надёжнее',
  'End': 'Конец',
  'End time': 'Время конца',
  'Enter a calendar name': 'Укажите название календаря',
  'Enter a category name': 'Укажите название категории',
  'Enter a folder name': 'Укажите название папки',
  'Enter a login and password': 'Введите логин и пароль',
  'Enter a valid email address': 'Укажите корректный адрес почты',
  'Enter a name': 'Укажите название',
  'Enter a project name': 'Укажите название проекта',
  'Enter a title': 'Укажите название',
  'Enter an account name': 'Укажите название счёта',
  'Enter an amount above zero': 'Укажите сумму больше нуля',
  'Enter an amount, e.g. 4500': 'Введите сумму, например 4500',
  'Enter an event name': 'Укажите название события',
  'Enter login and password': 'Введите логин и пароль',
  'Enter the amount received': 'Укажите полученную сумму',
  'Enter the budget amount': 'Укажите сумму лимита',
  'Enter the date and the actual balance': 'Укажите дату и фактический остаток',
  'Event': 'Событие',
  'Event not found': 'Событие не найдено',
  'Events of the day': 'События дня',
  'Every': 'Каждые',
  'Every day': 'Каждый день',
  'Every month': 'Каждый месяц',
  'Every quarter': 'Раз в квартал',
  'Every two weeks': 'Раз в две недели',
  'Every week': 'Каждую неделю',
  'Every year': 'Каждый год',
  'Everything for today is done.': 'Всё на сегодня закрыто.',
  'Expand': 'Развернуть',
  'expense': 'трата',
  'Expense': 'Трата',
  'Expense category': 'Категория трат',
  'Family member': 'Житель дома',
  'file': 'файл',
  'File': 'Файл',
  'File is missing on disk': 'Файл потерян на диске',
  'File not found': 'Файл не найден',
  'First occurrence': 'Первый раз',
  'First run': 'Первый запуск',
  'Folder': 'Папка',
  'Folder not found': 'Папка не найдена',
  'Forward': 'Вперёд',
  'From account': 'Со счёта',
  'From template': 'Из шаблона',
  'Good for rent that is charged on time. Salary is better confirmed: it arrives late, and recording it ahead of time would skew the balance': 'Годится для аренды, которую списывают в срок. Зарплату лучше подтверждать: она приходит с задержкой, и запись вперёд времени испортит остаток',
  'Google linked. You can now use the button on the sign-in screen.': 'Google привязан. Теперь можно входить кнопкой на экране входа.',
  'Google sign-in is not configured': 'Вход через Google не настроен',
  'H': 'В',
  'Hand it to the account owner. On first sign-in they will be asked to set their own password.': 'Передайте его владельцу учётки. При первом входе система попросит задать свой пароль.',
  'Heading {level}': 'Заголовок {level}',
  'Hide calendar {name}': 'Скрыть календарь {name}',
  'High': 'Высокий',
  'Highlight': 'Выделение',
  'History': 'История',
  'History is empty — the note has not been edited since creation.': 'История пуста — заметку ещё не правили после создания.',
  'I': 'К',
  'In progress': 'В работе',
  'Inbox': 'Входящие',
  'Inbox cannot be archived': 'Входящие нельзя архивировать',
  'Inbox cannot be deleted': 'Входящие удалить нельзя',
  'income': 'доход',
  'Income': 'Доход',
  'Income category': 'Категория доходов',
  'Internal server error': 'Внутренняя ошибка сервера',
  'Invalid login address': 'Некорректный логин-адрес',
  'Invalid path': 'Некорректный путь',
  'Invalid request': 'Некорректный запрос',
  'Invalid request parameters': 'Некорректные параметры запроса',
  'Invalid settings key': 'Некорректный ключ настройки',
  'Invitation': 'Приглашение',
  'Invite with a link': 'Пригласить по ссылке',
  'Issued password': 'Выданный пароль',
  'Italic': 'Курсив',
  'Its nested tasks will be deleted with it: {n}.': 'Вместе с ней удалятся вложенные задачи: {n}.',
  'Join': 'Присоединиться',
  'KB': 'КБ',
  'Kid': 'Ребёнок',
  'Kind': 'Вид',
  'Language': 'Язык',
  'left ': 'осталось ',
  'Limit must be greater than zero': 'Лимит должен быть больше нуля',
  'Link': 'Привязать',
  'Link from {from} · valid until {to}': 'Ссылка от {from} · действует до {to}',
  'Link Google first — otherwise there is no way left to sign in': 'Сначала привяжите Google — иначе входить будет нечем',
  'Link to a note': 'Ссылка на заметку',
  'Link to another note with double square brackets. Follow it with Cmd or Ctrl and a click.': 'Ссылка на другую заметку — двойные квадратные скобки. Переход по ней: Cmd или Ctrl и щелчок.',
  'Linked': 'Привязан',
  'Links to': 'Ссылается на',
  'List': 'Список',
  'Loading…': 'Загружаю…',
  'Login': 'Логин',
  'Login (email)': 'Логин (email)',
  'Login address': 'Логин-адрес',
  'Low': 'Низкий',
  'Mark as done': 'Отметить выполненной',
  'Matches the bank': 'Сходится с банком',
  'MB': 'МБ',
  'Member': 'Пользователь',
  'Member not found': 'Пользователь не найден',
  'Mentioned by': 'Упоминают эту',
  'Monday': 'Понедельник',
  'Money': 'Деньги',
  'Month': 'Месяц',
  'Month must be YYYY-MM': 'Нужен месяц в формате ГГГГ-ММ',
  'Month summary': 'Итоги месяца',
  'Monthly budget': 'Лимит на месяц',
  'more': 'ещё',
  'More': 'Ещё',
  'Money here is set aside: it stays out of the spendable total.': 'Деньги здесь отложены: они не входят в доступный итог.',
  'Move to archive': 'Убрать в архив',
  'Name': 'Имя',
  'Nested task': 'Вложенная задача',
  'Nested task name': 'Название вложенной задачи',
  'Never reconciled': 'Не сверялся',
  'New': 'Новая',
  'New account': 'Новый счёт',
  'New budget': 'Новый лимит',
  'New calendar': 'Новый календарь',
  'New event': 'Новое событие',
  'New folder': 'Новая папка',
  'New password': 'Новый пароль',
  'New project': 'Новый проект',
  'New recurring transaction': 'Новая регулярная операция',
  'New task': 'Новая задача',
  'New task in this project': 'Новая задача в этом проекте',
  'New template': 'Новый шаблон',
  'New transaction': 'Новая операция',
  'Next 7 days': 'Ближайшая неделя',
  'Next month': 'Следующий месяц',
  'Next occurrence scheduled for {date}': 'Повтор назначен на {date}',
  'No accounts yet. Start with wherever the money is: a card, cash, a piggy bank.': 'Счетов пока нет. Начните с того, где лежат деньги: карта, наличные, копилка.',
  'No budgets. Set one on a category and you will see how much of it is left.': 'Лимитов нет. Поставьте лимит на категорию — и станет видно, сколько от него осталось.',
  'No categories of this kind yet — create them on the Money page.': 'Категорий этого вида пока нет — их можно завести на странице денег.',
  'No category': 'Без категории',
  'No deadlines in the next 7 days.': 'Дедлайнов на неделю вперёд нет.',
  'No events today.': 'На сегодня событий нет.',
  'No file received': 'Файл не пришёл',
  'No folder': 'Без папки',
  'No members yet.': 'Пользователей нет.',
  'No note yet': 'Заметки пока нет',
  'No notes yet.': 'Заметок пока нет.',
  'No notes. Start with the “New” button.': 'Заметок нет. Начните с кнопки «Новая».',
  'No project': 'Без проекта',
  'No recurring transactions. Rent, subscriptions, salary — anything that repeats belongs here.': 'Регулярных операций нет. Сюда просятся аренда, подписки, зарплата — всё, что повторяется.',
  'No reminder': 'Не предупреждать',
  'No spending this month.': 'Трат за месяц нет.',
  'No such endpoint': 'Такого метода нет',
  'No such method': 'Такого метода нет',
  'No tasks. Add the first one — the input line is right above the list.': 'Задач нет. Добавьте первую — строка ввода прямо над списком.',
  'No transactions this month.': 'За этот месяц операций нет.',
  'Nobody to pick yet: the hub has a single account. Create personal accounts in People — everyone will show up here.': 'Выбирать пока не из кого: в доме одна учётная запись. Заведите личные учётки в разделе «Пользователи» — тогда здесь появятся все домочадцы.',
  'Normal': 'Обычный',
  'Not configured on the server': 'Не настроен на сервере',
  'Not linked': 'Не привязан',
  'Not saved': 'Не сохранено',
  'Note': 'Заметка',
  'Note not found': 'Заметка не найдена',
  'Notes': 'Заметки',
  'Nothing found': 'Ничего не нашлось',
  'Nothing here yet.': 'Пока пусто.',
  'Nothing is planned for this period.': 'В этом промежутке ничего не запланировано.',
  'Nothing planned for today.': 'На сегодня ничего не запланировано.',
  'Nothing to change': 'Нечего менять',
  'Nowhere — a top-level category': 'Никуда — категория верхнего уровня',
  'Numbered list': 'Нумерованный список',
  'Occurrence date is required': 'Нужна дата экземпляра',
  'of': 'из',
  'Only a transfer has a second side': 'Вторая сторона бывает только у перевода',
  'Only for': 'Только на',
  'Only the owner can make a note private': 'Приватной заметку делает её владелец',
  'Only you can see its events — not even the administrator': 'Его события видите только вы — даже администратор не увидит',
  'Only you can see its transactions and balance': 'Операции и остаток видите только вы',
  'Opening': 'Открываю',
  'Optional — shows the age': 'Необязательно — покажет возраст',
  'or': 'или',
  'over by ': 'перерасход ',
  'Overdue': 'Просрочено',
  'Palette': 'Палитра',
  'Parent category not found': 'Родительская категория не найдена',
  'Parent must be a category of the same kind': 'Родитель должен быть категорией того же вида',
  'Parent task belongs to another project': 'Родительская задача из другого проекта',
  'Parent task not found': 'Родительская задача не найдена',
  'Password': 'Пароль',
  'Password changed': 'Пароль изменён',
  'Password created. It is shown only once.': 'Пароль создан. Он показывается один раз.',
  'Password must be at least 10 characters': 'Пароль должен быть не короче 10 символов',
  'Password sign-in': 'Вход по паролю',
  'Password updated. All devices were signed out — sign in again with the new password.': 'Пароль обновлён. Все устройства разлогинены — войдите заново с новым паролем.',
  'Passwords do not match': 'Пароли не совпадают',
  'People': 'Пользователи',
  'Period boundaries are required': 'Нужны границы периода',
  'personal': 'личный',
  'Personal': 'Личный',
  'Personal account': 'Личный счёт',
  'Pick a note — or': 'Выберите заметку — или',
  'Pick someone to see their profile.': 'Выберите, чей профиль открыть.',
  'Piggy bank': 'Копилка',
  'Place': 'Место',
  'Placeholders expand when a note is created:': 'Подстановки раскроются при создании заметки:',
  'Post': 'Провести',
  'Pre-filled for new accounts and budgets. Any ISO 4217 code': 'Подставляется в новые счета и лимиты. Любой код ISO 4217',
  'Previous month': 'Предыдущий месяц',
  'Priority': 'Приоритет',
  'Private': 'Приватная',
  'Project': 'Проект',
  'Project not found': 'Проект не найден',
  'Projects and tasks': 'Проекты и дела',
  'Quote': 'Цитата',
  'Range boundaries from and to are required': 'Нужны границы диапазона from и to',
  'receipt': 'чек',
  'Receipt': 'Чек',
  'Recent notes': 'Последние заметки',
  'Reconcile': 'Сверить',
  'Reconcile: {name}': 'Сверка: {name}',
  'Record an expense': 'Записать трату',
  'Recorded, hide': 'Записал, скрыть',
  'Recurrence': 'Повторение',
  'Recurrence counts from the due date — set one': 'Повтор считается от срока — задайте дату',
  'Profile': 'Профиль',
  'Recurring': 'Регулярные',
  'Recurring transaction': 'Регулярная операция',
  'Regular': 'Обычная',
  'Release — the file will attach to the note': 'Отпустите — файл прикрепится к заметке',
  'Reload': 'Перезагрузить',
  'Remind': 'Предупредить',
  'Remove': 'Убрать',
  'Remove {color}': 'Убрать {color}',
  'Remove receipt': 'Убрать чек',
  'Rent, subscription, salary': 'Аренда, подписка, зарплата',
  'Reopen': 'Вернуть в работу',
  'Repeat': 'Повтор',
  'Repeats': 'Повторяется',
  'Report a bug': 'Сообщить об ошибке',
  'Reset': 'Сбросить',
  'Reset password': 'Сбросить пароль',
  'Restore': 'Вернуть',
  'Restore version': 'Вернуть версию',
  'Revoke': 'Отозвать',
  'Rule not found': 'Правило не найдено',
  'Run your own: one Docker container, the data stays at home.': 'Поставьте себе: один Docker-контейнер, данные остаются дома.',
  'Save': 'Сохранить',
  'Saved': 'Сохранено',
  'Saved so far': 'Накоплено',
  'Saving': 'Сохраняю',
  'Saving…': 'Сохраняю…',
  'Savings caption': 'Подпись к накоплениям',
  'Search': 'Поиск',
  'Search needs at least 3 characters': 'Для поиска нужно минимум 3 символа',
  'Search notes': 'Поиск по заметкам',
  'Search tasks, notes, events and files': 'Искать по задачам, заметкам, событиям и файлам',
  'Server unavailable': 'Сервер недоступен',
  'set aside': 'отложено',
  'Settings': 'Настройки',
  'Settings must be pairs of strings': 'Настройки должны быть парами строк',
  'Unknown timezone': 'Неизвестный часовой пояс',
  'Shared': 'Общий',
  'Shared with the family': 'Общая',
  'Show calendar {name}': 'Показать календарь {name}',
  'Show completed': 'Показывать выполненные',
  'Sign in': 'Войти',
  'Sign in again': 'Войти заново',
  'Sign in required': 'Нужно войти',
  'Sign in with Google': 'Войти через Google',
  'Sign out': 'Выйти',
  'Signing in': 'Вход в учётку',
  'Single-use, valid for a week. Send it to a family member — they fill in the rest themselves.': 'Одноразовая, действует неделю. Отправьте её домочадцу — остальное он заполнит сам.',
  'Skip this occurrence': 'Отменить этот раз',
  'Someday': 'Когда-нибудь',
  'Something went wrong': 'Не получилось',
  'Soon': 'Скоро',
  'Source code': 'Исходный код',
  'Spending': 'Траты',
  'Start': 'Начало',
  'Start time': 'Время начала',
  'Start writing. [[Link]] connects notes': 'Начните писать. [[Ссылка]] связывает заметки',
  'Status': 'Статус',
  'Stock color': 'Стандартный цвет',
  'Story': 'Стори',
  'Subcategories roll up into the parent in the summary; the parent limit counts their spending': 'Подкатегории сворачиваются в родителя в сводке, лимит родителя считает их траты',
  'Subtask': 'Подзадача',
  'Sunday': 'Воскресенье',
  'Support': 'Поддержка',
  'Switch to dark theme': 'Включить тёмную тему',
  'Switch to light theme': 'Включить светлую тему',
  'Table': 'Таблица',
  'Target amount': 'Нужная сумма',
  'Target date': 'Дата цели',
  'Task': 'Задача',
  'Task closed. The next occurrence is scheduled for {date}.': 'Задача закрыта. Следующий повтор назначен на {date}.',
  'Task not found': 'Задача не найдена',
  'Task: {project}': 'Задача: {project}',
  'Tasks': 'Задачи',
  'Tasks for today': 'Задачи на сегодня',
  'Tasks nest at most three levels deep: story, task, subtask': 'Глубже трёх уровней задачи не вкладываются: стори, таск, сабтаск',
  'Tasks with a due date': 'Задачи со сроком',
  'Template': 'Шаблон',
  'Template not found': 'Шаблон не найден',
  'Templates': 'Шаблоны',
  'Templates stay out of the main list and are offered when creating a note': 'Шаблон не попадает в общий список и предлагается при создании заметки',
  'The account has {n} {unit}. Deleting wipes them too — archiving is safer.': 'По счёту {n} {unit}. Удаление сотрёт и их — лучше убрать счёт в архив.',
  'The account has transactions — the currency cannot change, create a new account': 'У счёта есть операции — валюту менять нельзя, создайте новый счёт',
  'The administrator cannot disable the password: it is the emergency entrance': 'Администратору пароль отключить нельзя: это аварийный вход',
  'The administrator manages accounts and settings but cannot see anyone’s private notes — queries filter by owner with no exception for the role.': 'Администратор управляет учётками и настройками, но не видит чужие приватные заметки — выборки фильтруются по владельцу без исключений для роли.',
  'The API is up. The UI runs in dev mode at http://localhost:5173': 'API работает. Интерфейс в режиме разработки: http://localhost:5173',
  'The archive is empty. A project gets here from its own settings.': 'В архиве пока ничего нет. Проект попадает сюда из своих настроек.',
  'The calendar has {n} {unit}. Deleting the calendar deletes its events too.': 'В календаре {n} {unit}. Удаление календаря удалит и события.',
  'The category itself': 'Само по себе',
  'The countdown counts down to it': 'До неё идёт отсчёт',
  'The currencies differ and there is no exchange rate — enter the amount actually received': 'Валюты разные, а курса в системе нет — введите, сколько пришло по факту',
  'The currency cannot be changed once the account has transactions': 'Валюту потом не сменить, если по счёту уже есть операции',
  'The currency code is three capital letters, e.g. RSD or EUR': 'Код валюты — три заглавные буквы, например RSD или EUR',
  'The current password is incorrect': 'Текущий пароль указан неверно',
  'The current state stays in history; the rollback can be undone.': 'Текущее состояние останется в истории, откат можно будет отменить.',
  'The date is today. For a transfer, income or another date use the “Transaction” button.': 'Дата — сегодня. Перевод, доход или другую дату задайте кнопкой «Операция».',
  'The event does not repeat — delete it entirely': 'Событие не повторяется — удалите его целиком',
  'The event ends before it starts': 'Конец события раньше начала',
  'The event needs a title': 'У события должно быть название',
  'The file is missing on disk': 'Файл потерян на диске',
  'The budget is {n} GB — once it runs out, new uploads are refused. Attachments are not part of the backup archive, so keep an eye on growth.': 'Бюджет — {n} ГБ, при исчерпании новые загрузки отклоняются. Вложения не попадают в архив бэкапа, так что за ростом стоит следить.',
  'The hub is already set up': 'Хаб уже настроен',
  'The issued password was shown once. Set your own before continuing.': 'Выданный пароль виден в логе сервера. Задайте свой, прежде чем продолжить.',
  'The hub was updated': 'Хаб обновился',
  'The link is invalid: expired or already used': 'Ссылка не действует: истекла или уже использована',
  'The name cannot be empty': 'Имя не может быть пустым',
  'The note belongs to someone else': 'Заметка принадлежит другому человеку',
  'The note needs a title': 'У заметки должен быть заголовок',
  'The photo is downscaled before upload — it only needs to show the amount and date': 'Снимок уменьшается перед отправкой — читать с чека нужно сумму и дату',
  'The project has {n} {unit}. Deleting the project deletes its tasks too — archive the project or move them first.': 'В проекте {n} {unit}. Удаление проекта удалит и задачи — сначала уберите проект в архив или перенесите их.',
  'The request body is not valid JSON': 'Тело запроса не разобрать как JSON',
  'The server is unreachable': 'Сервер недоступен',
  'The task needs a title': 'У задачи должно быть название',
  'The week ahead is clear.': 'Неделя впереди свободна.',
  'There is no note for this date yet': 'На эту дату заметки ещё нет',
  'There is no reason to request more than a year': 'Диапазон больше года запрашивать незачем',
  'They work in the title too.': 'Работают и в заголовке.',
  'Things to do': 'Что нужно сделать',
  'Things to remember': 'Что нужно помнить',
  'This account belongs to someone else': 'Этот счёт принадлежит другому человеку',
  'This calendar belongs to someone else': 'Этот календарь принадлежит другому человеку',
  'This category has subcategories — detach them first': 'У категории есть подкатегории — сначала отвяжите их',
  'This Google account is already linked to another account.': 'Этот Google-аккаунт уже привязан к другой учётке.',
  'This Google account is not linked to any hub account. Sign in with a password and link it in Settings.': 'Этот Google-аккаунт не привязан ни к одной учётке. Войдите по паролю и привяжите его в настройках.',
  'This is a demo with sample data: you get your own private copy, so touch anything you like. After a couple idle hours it vanishes without a trace.': 'Это демо с примером данных: у вас будет собственная копия, трогайте что угодно. Через пару часов простоя она исчезнет без следа.',
  'This link is no longer valid: it has expired or was already used': 'Ссылка не действует: истекла или уже использована',
  'This link is no longer valid: it has expired or was already used. Ask the person who runs the hub for a new one.': 'Ссылка не действует: истекла или уже использована. Попросите новую у того, кто ведёт хаб.',
  'This month': 'Этот месяц',
  'this month only': 'только этот месяц',
  'This section is for the administrator only': 'Раздел доступен только администратору',
  'Three days before': 'За три дня',
  'Title': 'Название',
  'To account': 'На счёт',
  'To do': 'К работе',
  'Today': 'Сегодня',
  'today': 'сегодня',
  'Tomorrow': 'Завтра',
  'Too many attempts. Try again in 15 minutes': 'Слишком много попыток. Попробуйте через 15 минут',
  'Too Many Requests': 'Too Many Requests',
  'Too many settings': 'Слишком много настроек',
  'Too many settings at once': 'Слишком много настроек за раз',
  'Transaction': 'Операция',
  'Transaction not found': 'Операция не найдена',
  'Transactions': 'Операции',
  'Transfer': 'Перевод',
  'Transfers have no category': 'У перевода категории нет',
  'Try again': 'Ещё раз',
  'Try the demo': 'Попробовать демо',
  'Turn off': 'Выключить',
  'Two weeks before': 'За две недели',
  'Unarchive': 'Вернуть из архива',
  'Unassigned': 'Не назначен',
  'unconfirmed': 'не подтверждён',
  'Unlink': 'Отвязать',
  'Untitled': 'Без названия',
  'Urgent': 'Срочно',
  'useDialogs called outside DialogProvider': 'useDialogs вызван вне DialogProvider',
  'Version not found': 'Версия не найдена',
  'Week': 'Неделя',
  'Week starts on': 'Начало недели',
  'Time zone': 'Часовой пояс',
  'Follow the server clock': 'По часам сервера',
  'Shared by the whole family, unlike the two settings above: it decides when today becomes tomorrow for due tasks, budget periods and recurring payments.':
    'Общая для всей семьи, в отличие от двух настроек выше: от неё зависит, когда сегодня становится завтра для сроков задач, периодов бюджета и регулярных операций.',
  'Today there:': 'Сейчас там:',
  'What and when': 'Что и когда',
  'What they sign in with, and where password recovery is sent. A new address arrives unconfirmed — until they open the link mailed to it, it cannot recover the account.': 'С этим адресом человек входит, на него же уходит восстановление пароля. Новый адрес приходит неподтверждённым: пока по ссылке из письма не перейдут, восстановить учётку через него нельзя.',
  'Where': 'Где',
  'Who is going': 'Кто идёт',
  'Who lives here': 'Кто живёт в доме',
  'with confirmation': 'с подтверждением',
  'Wrong category kind: expenses and income use different ones': 'Категория не того вида: у трат и доходов они разные',
  'Your name — so the family knows who has it covered': 'Ваше имя — чтобы семья знала, что подарок за вами',
  'Wrong login or password': 'Неверный логин или пароль',
  'Year of birth': 'Год рождения',
  'You can adjust the amount before posting: a salary with a bonus or a water bill rarely matches the plan.': 'Сумму можно поправить перед проведением: зарплата с премией или счёт за воду редко совпадают с плановыми.',
  'You cannot disable yourself': 'Нельзя отключить самого себя',
  'You have been invited to Neiliro. Set up your account:': 'Вас пригласили в Neiliro. Заполните свою учётку:',
  'You will only be able to sign in with Google. If the Google account becomes unavailable, the administrator can restore access by resetting your password.': 'Войти можно будет только через Google. Если гугл-аккаунт станет недоступен, вход вернёт администратор сбросом пароля.',
  'Your own colors for projects, accounts, categories and calendars — on top of the stock ones. Grows from here and from the "+" button right in the color picker.': 'Свои цвета для проектов, счетов, категорий и календарей — поверх стандартных. Пополняется и отсюда, и кнопкой «+» прямо в выборе цвета.',
  'Zero — the goal is only a countdown': 'Ноль — только отсчёт, без накоплений',

  // ── Разделы внутри списка ─────────────────────────────────────────────
  'New section': 'Новый раздел',
  'Name of the section': 'Название раздела',
  'Delete the section': 'Удалить раздел',
  '“{title}” will be removed. The items in it stay on the list.':
    '«{title}» будет удалён. Пункты из него останутся в списке.',
  'Add to “{section}”': 'Добавить в «{section}»',
  'Section not found': 'Раздел не найден',
  'Section not found in this list': 'В этом списке такого раздела нет',

  // ── Управление списком и ссылка на список ─────────────────────────────
  'Rename': 'Переименовать',
  'Rename the list': 'Переименовать список',
  'Name of the list': 'Название списка',
  'Delete the list': 'Удалить список',
  '“{title}” and everything on it will be deleted.': '«{title}» и всё, что в нём, будет удалено.',
  '“{title}” and everything on it will be deleted, and its public link will stop working.':
    '«{title}» и всё, что в нём, будет удалено, а публичная ссылка перестанет работать.',
  'Share this list by link': 'Поделиться списком по ссылке',
  'Anyone with this link can see this list and tick items off — nothing else.':
    'Любой, у кого есть ссылка, увидит этот список и сможет отмечать пункты — и ничего больше.',
  'Shared list': 'Общий список',
  'Tick things off as you go — the family sees it too.':
    'Отмечайте по ходу — семья это тоже видит.',
  'This list is empty.': 'Список пуст.',

  // ── Ссылка на одно событие (гостевая страница) ────────────────────────
  'Share this event by link': 'Поделиться событием по ссылке',
  'Anyone with this link sees this event only — not the calendar it is in.':
    'Любой, у кого есть ссылка, увидит только это событие — не календарь, в котором оно лежит.',
  'You are invited': 'Вас приглашают',
  'When': 'Когда',
  'Details': 'Подробности',
  'Add to my calendar': 'Добавить в мой календарь',

  // ── Подписка на календарь (ICS-фид) ───────────────────────────────────
  'Not found': 'Не найдено',
  'Subscribe in your calendar': 'Подписаться в календаре',
  'Add the family calendar to the calendar app on your phone or laptop. The link is read-only and shows only what you can see in the hub.':
    'Добавьте семейный календарь в приложение календаря на телефоне или ноутбуке. Ссылка только для чтения и показывает лишь то, что вы видите в хабе.',
  'Create the link': 'Создать ссылку',
  'Revoke the link': 'Отозвать ссылку',
  'Every device subscribed to this link stops receiving updates. Revoke it?':
    'Все устройства, подписанные на эту ссылку, перестанут получать обновления. Отозвать?',
  'Paste this address into Apple Calendar, Google Calendar or Outlook as a subscription.':
    'Вставьте этот адрес в Apple Calendar, Google Календарь или Outlook как подписку.',

  // ── Общие списки (#11) ────────────────────────────────────────────────
  'Lists': 'Списки',
  'Shopping': 'Покупки',
  'Shared with the whole family': 'Общее для всей семьи',
  'New list': 'Новый список',
  'Name of the new list': 'Название нового списка',
  'Add an item and press Enter': 'Добавьте пункт и нажмите Enter',
  'Nothing here yet. Add the first item above.': 'Пока пусто. Добавьте первый пункт выше.',
  'Clear checked ({n})': 'Убрать отмеченные ({n})',
  'List not found': 'Список не найден',
  'Item not found': 'Пункт не найден',

  // ── Сброс пароля по email (hosted) ────────────────────────────────────
  'Forgot your password?': 'Забыли пароль?',
  'Password reset': 'Сброс пароля',
  'Enter the address you sign in with and we will send a link to set a new password.':
    'Введите адрес, с которым вы входите — пришлём ссылку для смены пароля.',
  'Send the link': 'Отправить ссылку',
  'Sending': 'Отправляю',
  'If that address has an account here, a link is on its way. It works once, for one hour.':
    'Если у этого адреса есть аккаунт, ссылка уже в пути. Она работает один раз и один час.',
  'Back to sign in': 'Вернуться к входу',
  'This link is not valid. Request a new one from the sign-in screen.':
    'Ссылка недействительна. Запросите новую на экране входа.',
  'Choose a new password. Signing in elsewhere will be required again.':
    'Выберите новый пароль. На других устройствах придётся войти заново.',
  'Save and sign in': 'Сохранить и войти',
  'This link has expired — request a new one': 'Ссылка истекла — запросите новую',
  'This link is not valid': 'Ссылка недействительна',
  'That login is already taken': 'Этот логин уже занят',
  'Address confirmation': 'Подтверждение адреса',
  'Confirming…': 'Подтверждаю…',
  'Address confirmed. If you ever forget your password, you can now reset it by email.':
    'Адрес подтверждён. Если забудете пароль, теперь его можно сбросить по почте.',
  'Sign in and use the reminder at the top of the page to send a fresh link.':
    'Войдите и отправьте новую ссылку — напоминание наверху страницы.',
  'Open Neiliro': 'Открыть Neiliro',
  'Confirm {email} so you can reset your password by email if you forget it.':
    'Подтвердите {email} — тогда забытый пароль можно будет сбросить по почте.',
  'Sent. Open the link in that mailbox to confirm the address.':
    'Отправлено. Откройте ссылку в этом ящике, чтобы подтвердить адрес.',

  // ── Family mail (v1) ──────────────────────────────────────────────────
  '(empty message)': '(пустое письмо)',
  '(no subject)': '(без темы)',
  '(unchanged)': '(не менялся)',
  'App password for Gmail': 'App password для Gmail',
  'Ask the administrator to connect the family mailbox in Settings.': 'Попросите администратора подключить семейный ящик в настройках.',
  'Connect the family mailbox in Settings to start.': 'Чтобы начать, подключите семейный ящик в настройках.',
  'Connected. New messages: {n}': 'Подключено. Новых писем: {n}',
  'Family': 'Семья',
  'Family address': 'Семейный адрес',
  'Family mailbox': 'Семейный ящик',
  'Folder to read': 'Какую папку читать',
  'Has attachments': 'Есть вложения',
  'IMAP host': 'IMAP-хост',
  'INBOX, or a dedicated label so the hub never touches personal mail': 'INBOX — или отдельный ярлык, чтобы хаб не касался личной почты',
  'Letters sent here show up in Mail on their own — there is nothing to connect. Hand it out to the school, the utility company and the booking sites.': 'Письма на этот адрес сами появляются в разделе «Почта» — подключать ничего не нужно. Давайте его школе, коммунальщикам и сервисам бронирования.',
  'Mail': 'Почта',
  'Mailbox is not configured': 'Ящик не настроен',
  'Mailbox sync error: {error}': 'Ошибка синхронизации ящика: {error}',
  'Make it a task': 'Сделать задачей',
  'Message not found': 'Письмо не найдено',
  'No mail yet. Forward a letter to the family address — it will appear here.': 'Писем пока нет. Перешлите письмо на семейный адрес — оно появится здесь.',
  'No mailbox to poll': 'Синхронизировать нечего — ящик не подключён',
  'One shared address for school letters, bills and bookings — visible to the whole family, one click from a letter to a task.': 'Один общий адрес для писем из школы, счетов и броней — виден всей семье, из письма один клик до задачи.',
  'Open Settings': 'Открыть настройки',
  'Other': 'Другая',
  'Open task': 'Открыть задачу',
  'Password is required': 'Нужен пароль',
  'Pick a letter on the left': 'Выберите письмо слева',
  'Would rather use a mailbox of your own? Connect it below and it takes over from the address above.': 'Хотите использовать свой ящик? Подключите его ниже — он заменит адрес выше.',
  'Your family address': 'Адрес вашей семьи',
  '1. Scan the QR code with the authenticator app:': '1. Отсканируйте QR-код приложением-аутентификатором:',
  '2. Enter the code the app shows:': '2. Введите код, который показывает приложение:',
  'A second lock on password sign-in: a six-digit code from an authenticator app (Google Authenticator, 1Password, …). Recommended for the administrator — that account cannot hide behind Google.': 'Второй замок на парольном входе: шестизначный код из приложения-аутентификатора (Google Authenticator, 1Password, …). Рекомендуется администратору — этот аккаунт не может спрятаться за Google.',
  'Browser': 'Браузер',
  'Devices': 'Устройства',
  'Enter a current code to confirm — turning it off requires the phone, not just this session.': 'Введите текущий код для подтверждения — для отключения нужен телефон, а не только эта сессия.',
  'Enter the code': 'Введите код',
  'Hide': 'Скрыть',
  'Lost the authenticator? The server owner runs npm run admin:reset — it resets the password and removes the second factor.': 'Потеряли аутентификатор? Владелец сервера запускает npm run admin:reset — он сбрасывает пароль и снимает второй фактор.',
  'No camera at hand? Enter the key manually:': 'Нет камеры под рукой? Введите ключ вручную:',
  'On — password sign-in asks for a code': 'Включено — парольный вход спрашивает код',
  'QR code for the authenticator app': 'QR-код для приложения-аутентификатора',
  'Session not found': 'Сессия не найдена',
  'Show': 'Показать',
  'Sign-in expired — start over': 'Вход истёк — начните заново',
  'Start the setup first': 'Сначала начните настройку',
  'The six-digit code from your authenticator app.': 'Шестизначный код из вашего приложения-аутентификатора.',
  'Turn on': 'Включить',
  'Two-factor authentication': 'Двухфакторная аутентификация',
  'Two-factor authentication is already enabled': 'Двухфакторная аутентификация уже включена',
  'Two-factor authentication is not enabled': 'Двухфакторная аутентификация не включена',
  'Two-factor authentication is off.': 'Двухфакторная аутентификация выключена.',
  'Two-factor authentication is on. Codes are now required at password sign-in.': 'Двухфакторная аутентификация включена. Теперь парольный вход требует код.',
  'Unknown device': 'Неизвестное устройство',
  'Wrong code': 'Неверный код',
  'idle': 'без активности',
  'seen {when}': 'активность {when}',
  'signed in {when}': 'вход {when}',
  'this device': 'это устройство',
  'Done.': 'Готово.',
  'Every device except this one will be signed out. Useful when a phone is lost — the device also clears its offline copy the next time it comes online.': 'Все устройства, кроме этого, будут разлогинены. Пригодится при потере телефона — при первом выходе в сеть устройство также сотрёт свою офлайн-копию.',
  'Replies': 'Ответы',
  'Sign out everywhere else': 'Выйти на остальных',
  'Sign out on other devices?': 'Выйти на других устройствах?',
  'This is the only session': 'Это единственная сессия',
  'Reply — it is sent from the family address with your name': 'Ответ — уйдёт с семейного адреса от вашего имени',
  'Reply sent from the family address': 'Ответ отправлен с семейного адреса',
  'Reply text is required': 'Нужен текст ответа',
  'SMTP host': 'SMTP-хост',
  'Save and check': 'Сохранить и проверить',
  'Saved. Checking the mailbox…': 'Сохранено. Проверяю ящик…',
  'Send reply': 'Отправить ответ',
  'Show earlier days ({n})': 'Показать более ранние дни ({n})',
  'Synced {when}': 'Синхронизировано {when}',
  'The household paperwork inbox': 'Домашняя канцелярия',
  'The shared address the Mail section reads. A dedicated mailbox works best; a personal Gmail works too — filter letters into a separate label and set it as the folder below.': 'Общий адрес, который читает раздел «Почта». Лучше всего отдельный ящик; личный Gmail тоже подходит — настройте фильтр в отдельный ярлык и укажите его как папку ниже.',
  'task': 'задача',
  'Username': 'Логин',

  // ── Family archive and self-deletion (Settings → admin) ──
  'Family archive': 'Семейный архив',
  'The complete archive: the database plus every attachment, as one tar.gz. It restores into a self-hosted hub with the import script — your data is never locked in.': 'Полный архив: база данных и все вложения одним tar.gz. Восстанавливается в self-hosted-хабе скриптом импорта — ваши данные никогда не заперты.',
  'Download the archive': 'Скачать архив',
  'On a large family this takes a moment — the download starts once the archive is ready.': 'На большой семье это занимает время — скачивание начнётся, когда архив будет готов.',
  'Danger zone': 'Опасная зона',
  'This deletes the family for everyone: the database, every attachment, every account. There is no undo. Encrypted backups expire on their own within 14 days.': 'Это удалит семью для всех: базу данных, все вложения, все аккаунты. Отменить нельзя. Зашифрованные резервные копии истекут сами в течение 14 дней.',
  'Delete the family…': 'Удалить семью…',
  'Download the archive first — once the family is gone, so is the data.': 'Сначала скачайте архив — вместе с семьёй исчезнут и данные.',
  'Code from the authenticator app': 'Код из приложения-аутентификатора',
  'Type the family address name ({slug}) to confirm': 'Введите имя адреса семьи ({slug}) для подтверждения',
  'Delete the family forever': 'Удалить семью навсегда',
  'Family deletion is available on the hosted service only': 'Удаление семьи доступно только в облачном сервисе',
  'The confirmation phrase does not match the family address': 'Контрольная фраза не совпадает с адресом семьи',

  // ── Family address: the one rename (Settings → admin, first sign-in offer) ──
  'Hub address': 'Адрес хаба',
  'Your hub lives at {url}. You can change that once, until {when} — after that the address is permanent.': 'Ваш хаб живёт по адресу {url}. Его можно сменить один раз, до {when} — после этого адрес окончательный.',
  'New address': 'Новый адрес',
  '3–30 lowercase letters, digits and dashes.': '3–30 строчных латинских букв, цифр и дефисов.',
  'Everything moves with the address: everyone signs in again at the new one, old links stop working, and the family mail address becomes {email}.': 'Вместе с адресом переезжает всё: все входят заново по новому адресу, старые ссылки перестают работать, а почтовый адрес семьи становится {email}.',
  'Everything moves with the address: everyone signs in again at the new one, and old links stop working.': 'Вместе с адресом переезжает всё: все входят заново по новому адресу, старые ссылки перестают работать.',
  'Change the address…': 'Сменить адрес…',
  'Move the family to {url}?': 'Переехать на {url}?',
  'This is the one rename the family gets — there is no second one. Everyone signs in again at the new address, and old links stop working.': 'Это единственное переименование — второго не будет. Все входят заново по новому адресу, старые ссылки перестают работать.',
  'Move the family': 'Переехать',
  'Pick your family address?': 'Выбрать адрес семьи?',
  'Your hub lives at {url}. For the first 24 hours after setup you can change that once — to something easier to say out loud. After that the address is permanent.': 'Ваш хаб живёт по адресу {url}. В первые 24 часа после настройки его можно сменить один раз — на что-то, что легко сказать вслух. После этого адрес окончательный.',
  'Keep this address': 'Оставить этот',
  'Choose an address': 'Выбрать адрес',
  'The family address is managed by the hosted service only': 'Адрес семьи есть только в облачном сервисе',
  'The family address can no longer be changed': 'Адрес семьи уже нельзя изменить',
  'An address is 3–30 lowercase letters, digits and dashes, starting and ending with a letter or digit': 'Адрес — 3–30 строчных латинских букв, цифр и дефисов, в начале и в конце буква или цифра',
  'That is already the family address': 'Это и есть текущий адрес семьи',
  'This address is not available': 'Этот адрес недоступен',

  // ── Founder invitation: the hosted first run behind a mailed token (#157) ──
  'The address the invitation came to — already confirmed for password recovery.': 'Адрес, на который пришло приглашение — уже подтверждён для восстановления пароля.',
  'A different address than the invitation came to: we will ask you to confirm it.': 'Адрес отличается от того, куда пришло приглашение: мы попросим его подтвердить.',
};

/** one / few / many, keyed by the English singular used in plural() calls. */
export const ruPlurals: Record<string, [string, string, string]> = {
  day: ['день', 'дня', 'дней'],
  week: ['неделю', 'недели', 'недель'],
  month: ['месяц', 'месяца', 'месяцев'],
  year: ['год', 'года', 'лет'],
  task: ['задача', 'задачи', 'задач'],
  'active session': ['активная сессия', 'активные сессии', 'активных сессий'],
  'session closed': ['сессия закрыта', 'сессии закрыты', 'сессий закрыто'],
  transaction: ['операция', 'операции', 'операций'],
  event: ['событие', 'события', 'событий'],
  file: ['файл', 'файла', 'файлов'],
};
